/* ==========================================================================
   Silph TCG — faire respecter le maximum de quantité, y compris à la saisie.

   L'attribut `max` d'un champ nombre ne bloque que les flèches et la
   validation native du navigateur. Or le formulaire produit de Dawn part en
   requête réseau, pas en soumission classique : la validation native n'est
   jamais consultée. Résultat, un client qui efface le « 2 » et tape « 9 »
   passait à travers la limite alors que le bouton « + » était bien éteint.

   On ramène donc la valeur au maximum, en phase de capture pour passer avant
   les gestionnaires de Dawn — sinon il lit la valeur d'origine et l'envoie.
   ========================================================================== */

(function () {
  'use strict';

  function plafond(champ) {
    if (!champ || !champ.classList || !champ.classList.contains('quantity__input')) return null;
    var max = parseInt(champ.getAttribute('max'), 10);
    return max > 0 ? max : null;
  }

  function ramener(champ) {
    var max = plafond(champ);
    if (max === null) return;
    var valeur = parseInt(champ.value, 10);
    if (isNaN(valeur) || valeur <= max) return;
    champ.value = max;
    /* Un court éclat suffit à faire comprendre que la valeur a été corrigée ;
       la mention « Limité à N par commande » juste à côté dit pourquoi. */
    champ.classList.add('quantity__input--plafonne');
    window.setTimeout(function () {
      champ.classList.remove('quantity__input--plafonne');
    }, 900);
  }

  document.addEventListener('change', function (e) { ramener(e.target); }, true);

  /* Filet : sur la fiche produit, la valeur n'est lue qu'à l'envoi. Si le client
     tape son nombre puis clique droit sur « Ajouter au panier » sans quitter le
     champ, aucun `change` n'est parti encore. */
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.querySelectorAll) return;
      [].forEach.call(form.querySelectorAll('input.quantity__input'), ramener);
    },
    true
  );
})();
